import { Input as InputBlock } from 'components/Common/Input';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 35px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1279px) {
    padding: 20px 16px;
  }
`;

export const Modal = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  max-width: 811px;
  background: #ffffff;
  box-shadow: 4px 4px 39px 0px rgba(0, 0, 0, 0.07);
  padding: 60px 67px 216px 67px;
  box-sizing: border-box;
  border-radius: 32px;

  @media (max-width: 1279px) {
    padding: 32px 20px 60px;
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
`;

export const SubmitButton = styled.button`
  margin: auto;
  width: 100%;
  max-width: 341px;
  height: 43px;
  background: rgba(255, 45, 46, 1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 1);
  border: none;
  cursor: pointer;
`;

export const SearchButton = styled.button`
  right: -81px;
  width: 76px;
  height: 44px;
  background: rgba(255, 45, 46, 1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 1);
  border: none;
  cursor: pointer;
`;

export const Input = styled(InputBlock)<{
  error?: boolean;
  disabled?: boolean;
}>`
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: 100%;
  height: 44px;
  border-radius: 4px;
  padding: 7px 0px 7px 17px;
  box-sizing: border-box;
  item-align: center;
  background: ${({ theme, disabled }) => (disabled ? theme.color.Gray20 : theme.color.White)};
  border: 1px solid
    ${({ theme, disabled, error }) => (error ? 'red' : disabled ? theme.color.Gray20 : theme.color.Gray20)};
  color: ${({ theme, disabled }) => (disabled ? theme.color.Gray40 : theme.color.Black)};
  font-size: ${({ theme }) => theme.fontSize[13]};
  font-weight: 500;
  letter-spacing: -2.2%;
  line-height: 19.5px;
  ::placeholder {
    color: ${({ theme }) => theme.color.Gray30};
    font-size: ${({ theme }) => theme.fontSize[13]};
    font-weight: 500;
    letter-spacing: -2.2%;
    line-height: 19.5px;
  }
`;
